import { useMutation } from '@tanstack/react-query';
import { toCsv } from '../../../shared/analytics.js';
import { downloadCsv } from '../lib/download-csv.js';
import { api } from '../models/api-client.js';
import { useSession } from './session-context.jsx';

export function useExport() {
  const { user, filters } = useSession();
  return useMutation({
    mutationFn: () => api('/api/export', { body: {
      startDate: filters.dates[0],
      endDate: filters.dates[1],
      country: filters.country,
      device: filters.device,
      siteUrl: user.siteUrl,
    } }),
    onSuccess: rows => downloadCsv(toCsv(rows)),
  });
}
